import { render, staticRenderFns } from "./LatestPaperList.vue?vue&type=template&id=e891889e&scoped=true&"
import script from "@/scripts/Events/components/LatestPaperList?vue&type=script&lang=js&"
export * from "@/scripts/Events/components/LatestPaperList?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e891889e",
  null
  
)

export default component.exports